import React, { Fragment } from 'react';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const ReactTableActionsFormula = ({ data, Callback }) => {

  return (<Fragment>
    <td role="cell">
      <Tooltip title="Agregar">
        <IconButton onClick={() => {
          console.log("delete");
          Callback();
        }}>
          <DeleteForeverIcon />
        </IconButton>
      </Tooltip>
    </td>
  </Fragment>)
}

export default ReactTableActionsFormula;